import { useEffect } from 'react';

const titleMap = {
  OP: 'Opie AI Scribe - Powered By Insight Health',
  default: 'Insight Health',
};

type params = {
  tenant: keyof typeof titleMap;
};

export const useHtmlTitle = ({ tenant }: params) => {
  useEffect(() => {
    document.title = titleMap[tenant] || titleMap.default;
  }, [tenant]);
};
